<div class="two-column-layout">
        <app-tile
                [tabindex]="1"
                [icon]="'article'"
                [title]="'GENERAL.TEXT_OUTPUT' | translate"
                [text]="'ONBOARDING.PRESENTATION_MODE.TEXT_OUTPUT_DESCRIPTION' | translate"
                [ariaLabel]="('GENERAL.TEXT_OUTPUT' | translate) + ('GENERAL.BUTTON' | translate)"
                (tileClickEvent)="nextStepClick(presentationModeText)">
        </app-tile>
        <app-tile
                [tabindex]="2"
                [icon]="'volume_up'"
                [title]="'GENERAL.VOICE_OUTPUT' | translate"
                [text]="'ONBOARDING.PRESENTATION_MODE.VOICE_OUTPUT_DESCRIPTION' | translate"
                [ariaLabel]="('GENERAL.VOICE_OUTPUT' | translate) + ('GENERAL.BUTTON' | translate)"
                (tileClickEvent)="nextStepClick(presentationModeVoice)">
        </app-tile>
</div>
